import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTranslation } from 'react-i18next';

export type Brand = 'divus' | 'blueviza' | 'all';

interface BrandSelectorProps {
  value: Brand;
  onChange: (value: Brand) => void;
  includeAll?: boolean;
  className?: string;
  disabled?: boolean;
}

export function BrandSelector({
  value,
  onChange,
  includeAll = true,
  className,
  disabled = false,
}: BrandSelectorProps) {
  const { t } = useTranslation();

  return (
    <Select
      value={value}
      onValueChange={(v) => onChange(v as Brand)}
      disabled={disabled}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={t('finance.selectBrand', 'Select Brand')} />
      </SelectTrigger>
      <SelectContent>
        {includeAll && (
          <SelectItem value="all">
            {t('finance.allBrands', 'All Brands')}
          </SelectItem>
        )}
        <SelectItem value="divus">
          Divus
        </SelectItem>
        <SelectItem value="blueviza">
          BlueViza
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
